import { useTemplateOrCalculation } from '../../../../../../hooks/useTemplateOrCalculation';
import { useGetPickingInsightsQuery } from '../../../apiCalculationPickingResults';
import React, { useCallback, useMemo } from 'react';
import { StorePickingInsightsResponse } from '@ydistri/api-sdk';
import { getPickInsightsColumns } from '../../../pickingResultsLib';
import LoadingIndicator from '../../../../../../components/global/LoadingIndicator/LoadingIndicator';
import { DataTable, tableScroll } from '@ydistri/ds';
import ScrolledTableWrapper from '../../../../../../components/global/ScrolledTableWrapper/ScrolledTableWrapper';
import { ExpandableConfig } from 'antd/es/table/interface';
import TargetStorePickingInsightsDetailTable from './TargetStorePickingInsightsDetailTable';
import { useStoreTableColumnsProvider } from '../../../../../../hooks/useEntityTableColumnsProvider';
import { getStoreColumnsForPickingPerformance } from '../pickingPerformanceLib';
import { computeRemSize } from '@ydistri/theme';

const PickingPerformanceTable: React.FC = () => {
  const templateOrCalculation = useTemplateOrCalculation();
  const storeTableColumnsProvider = useStoreTableColumnsProvider();

  const { data, isFetching } = useGetPickingInsightsQuery(templateOrCalculation.id);

  const tableColumns = useMemo(() => {
    const storeColumns =
      getStoreColumnsForPickingPerformance<StorePickingInsightsResponse>(storeTableColumnsProvider);
    return getPickInsightsColumns(storeColumns);
  }, [storeTableColumnsProvider]);

  const rowKeyProvider = useCallback((record: StorePickingInsightsResponse) => record.store.id, []);

  const expandableConfig: ExpandableConfig<StorePickingInsightsResponse> = useMemo(
    () => ({
      expandedRowRender: record => {
        if (!('store' in record)) return null;
        return <TargetStorePickingInsightsDetailTable sourceStoreId={record.store.id} />;
      },
    }),
    [],
  );

  if (isFetching) {
    return <LoadingIndicator />;
  } else {
    if (data) {
      return (
        <ScrolledTableWrapper offset={80}>
          <DataTable<StorePickingInsightsResponse>
            id="store-picking-results"
            scroll={tableScroll}
            dataSource={data}
            columns={tableColumns}
            loading={isFetching}
            showHeader={true}
            height={computeRemSize(480)}
            rowKey={rowKeyProvider}
            showBorder={true}
            expandable={expandableConfig}
          />
        </ScrolledTableWrapper>
      );
    }
  }
};

export default PickingPerformanceTable;
